// extracted by mini-css-extract-plugin
module.exports = {"root":"fncRadioGroup_root__DjOyH","description":"fncRadioGroup_description__2xMFv","list":"fncRadioGroup_list__20fnd"};